module.exports = __webpack_public_path__ + "static/media/Illus-Diversity_2@2x.ae44a12f.png";